export default {
	getSearchMonths_({ searchParams: { strMt, endMt } }) {
		return [strMt, endMt];
	},
	getColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000956'), //품번
				prop: 'partNo',
				minWidth: '150px',
				align: 'center'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000964'), //영문품명
				prop: 'enPartNm',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000965'), //한글품명
				prop: 'koPartNm',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000966'), //중문품명
				prop: 'chPartNm',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002079'), //중문품명
				prop: 'serialNo',
				minWidth: '150px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000999'), //발생년월
				prop: 'occuDd',
				minWidth: '150px',
				align: 'center'
			},
			{
				label: 'ERP' + rootGetters['commonStore/getMessage_']('QWCC001000'), //발생수량
				prop: 'erpOccuQty',
				minWidth: '150px',
				sortable: false,
				align: 'left'
			},
			{
				label: 'HQMS' + rootGetters['commonStore/getMessage_']('QWCC001000'), //발생수량
				prop: 'occuQty',
				minWidth: '150px',
				sortable: false,
				align: 'left'
			}
		];
	}
};
